import { MessageSquare, Search, FileText, Truck, Home } from 'lucide-react';

const steps = [
  {
    icon: MessageSquare,
    number: '01',
    title: 'Anfrage stellen',
    description: 'Kontaktieren Sie uns telefonisch oder über unser Formular mit Ihren Start- und Zieladressen.',
  },
  {
    icon: Search,
    number: '02',
    title: 'Besichtigung',
    description: 'Wir besichtigen Ihre Wohnung vor Ort oder per Video-Call, um das Volumen exakt zu erfassen.',
  },
  {
    icon: FileText,
    number: '03',
    title: 'Fixpreis-Offerte',
    description: 'Sie erhalten eine transparente Offerte mit Fixpreis – ohne versteckte Kosten oder Überraschungen.',
  },
  {
    icon: Truck,
    number: '04',
    title: 'Zoll & Transport',
    description: 'Wir kümmern uns um alle Zollformalitäten und transportieren Ihr Umzugsgut sicher nach Deutschland.',
  },
  {
    icon: Home,
    number: '05',
    title: 'Ankunft & Aufbau',
    description: 'Am Zielort montieren wir Ihre Möbel und richten alles nach Ihren Wünschen ein. Fertig!',
  },
];

export default function Process() {
  return (
    <section id="ablauf" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-block bg-slate-100 text-slate-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            So einfach geht's
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Ihr Umzug in 5 Schritten
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Von der ersten Kontaktaufnahme bis zur Schlüsselübergabe – wir begleiten Sie professionell durch jeden Schritt.
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          {steps.map((step, index) => {
            const Icon = step.icon;
            const isLast = index === steps.length - 1;

            return (
              <div key={index} className="relative group">
                <div className="flex items-start space-x-6 mb-12">
                  <div className="flex-shrink-0 relative">
                    <div className="bg-slate-800 w-16 h-16 rounded-2xl flex items-center justify-center shadow-lg transition-all duration-300 group-hover:scale-110 group-hover:rotate-3 group-hover:shadow-2xl">
                      <Icon className="w-8 h-8 text-white" />
                    </div>
                    <div className="absolute -top-2 -right-2 bg-white border-2 border-slate-800 w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300 group-hover:scale-110">
                      <span className="text-xs font-bold text-slate-800">{step.number}</span>
                    </div>
                  </div>

                  <div className="flex-1 pt-2 transition-all duration-300 group-hover:translate-x-2">
                    <h3 className="text-2xl font-bold text-slate-900 mb-3">
                      {step.title}
                    </h3>
                    <p className="text-slate-600 text-lg leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>

                {!isLast && (
                  <div className="absolute left-8 top-16 w-0.5 h-12 bg-gradient-to-b from-slate-300 to-slate-100"></div>
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-16 relative bg-gradient-to-br from-slate-50 to-white rounded-2xl p-8 md:p-12 border-2 border-slate-100 overflow-hidden">
          <div className="absolute inset-0 opacity-5">
            <img
              src="/grenduebergang-schweiz-deutschland.jpeg"
              alt="Grenzübergang Schweiz Deutschland"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="relative z-10 max-w-3xl mx-auto text-center">
            <h3 className="text-3xl font-bold text-slate-900 mb-4">
              Bereit für Ihren stressfreien Umzug?
            </h3>
            <p className="text-slate-600 text-lg mb-8">
              Kontaktieren Sie uns noch heute für eine kostenlose Beratung und erhalten Sie innerhalb von 24 Stunden Ihre persönliche Offerte.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4">
              <button
                onClick={() => {
                  const element = document.getElementById('kontakt');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
                className="bg-slate-800 hover:bg-slate-900 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-2xl hover:scale-105"
              >
                Jetzt Offerte anfordern
              </button>
              <a
                href="tel:0800700100"
                className="bg-white hover:bg-slate-50 text-slate-800 px-8 py-4 rounded-lg font-semibold transition-all duration-300 shadow-md hover:shadow-xl hover:scale-105 border-2 border-slate-200"
              >
                0800 700 100 (Gratis)
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
